"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.calculateIndex = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuery = require("react-query");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _map = require("@nicbase/map");

var _mapping = require("@nicbase/mapping");

var _request = require("@nicbase/request");

var _booleanPointOnLine = _interopRequireDefault(require("@turf/boolean-point-on-line"));

var _helpers = require("@turf/helpers");

var _nearestPointOnLine = _interopRequireDefault(require("@turf/nearest-point-on-line"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _uuid = require("uuid");

var _routeMarker = require("./route-marker");

require("./route.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mapType = 'osm';

var createRouteFromWaypoints = function createRouteFromWaypoints(portalId, route) {
  return {
    type: 'CREATE_ROUTE_FROM_WAYPOINTS_REQUEST',
    headers: {
      version: 'v2',
      portalId: portalId
    },
    body: {
      route: route
    }
  };
};

var calculateIndex = function calculateIndex(routePt, coords, points) {
  var routePointsLine = (0, _helpers.lineString)(routePt);
  var snapped = (0, _nearestPointOnLine["default"])(routePointsLine, (0, _helpers.point)(coords), {
    units: 'kilometers'
  });
  var index = snapped.properties.index;
  var upperSegment = routePt.slice(index + 1);
  var newIndex = points.length - 1;

  if (upperSegment.length > 1) {
    newIndex = points.findIndex(function (wp) {
      return (0, _booleanPointOnLine["default"])(wp, (0, _helpers.lineString)(upperSegment));
    });
  }

  return newIndex;
};

exports.calculateIndex = calculateIndex;

var RouteMonitoringSection = function RouteMonitoringSection(_ref) {
  var _findAssetKind, _tour$route, _tourRoute$geometry$c, _tourRoute$geometry, _tour$wayPoints2;

  var tour = _ref.tour,
      tourRoute = _ref.tourRoute,
      isMonitoringEnabled = _ref.isMonitoringEnabled,
      onUpdate = _ref.onUpdate,
      setTourRoute = _ref.setTourRoute;

  var _useWidget = (0, _nicbaseReducers.useWidget)(),
      settings = _useWidget.settings.current;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _usePortalPois = (0, _hooks.usePortalPois)(portalId),
      pois = _usePortalPois.data;

  var profile = (_findAssetKind = (0, _mapping.findAssetKind)(tour.assetType)) !== null && _findAssetKind !== void 0 ? _findAssetKind : 'ROAD_VEHICLE';
  var wayPoints = (0, _react.useMemo)(function () {
    var _tour$wayPoints$reduc, _tour$wayPoints;

    return (_tour$wayPoints$reduc = (_tour$wayPoints = tour.wayPoints) === null || _tour$wayPoints === void 0 ? void 0 : _tour$wayPoints.reduce(function (result, wayPoint) {
      var wayPointPoi = pois === null || pois === void 0 ? void 0 : pois.find(function (poi) {
        return poi.id === wayPoint.poiId;
      });

      if (wayPointPoi) {
        var _latitude = wayPointPoi.latitude,
            _longitude = wayPointPoi.longitude,
            name = wayPointPoi.name,
            category = wayPointPoi.category,
            id = wayPointPoi.id;
        result.push({
          id: id,
          lat: _latitude,
          lng: _longitude,
          name: name,
          category: category.icon
        });
      }

      return result;
    }, [])) !== null && _tour$wayPoints$reduc !== void 0 ? _tour$wayPoints$reduc : [];
  }, [pois, tour.wayPoints]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      emptyRouteError = _useState2[0],
      setEmptyRouteError = _useState2[1];

  var _useState3 = (0, _react.useState)(wayPoints),
      _useState4 = _slicedToArray(_useState3, 2),
      routeWaypoints = _useState4[0],
      setRouteWaypoints = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      waypointIndex = _useState6[0],
      setWaypointIndex = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      draggableMarkers = _useState8[0],
      setDraggableMarkers = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      visibleMarker = _useState10[0],
      setVisibleMarker = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      onPolyline = _useState12[0],
      setOnPolyline = _useState12[1];

  var _useState13 = (0, _react.useState)(true),
      _useState14 = _slicedToArray(_useState13, 2),
      showVisibleMarker = _useState14[0],
      setShowVisibleMarker = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      observeMouseDownEvent = _useState16[0],
      setObserveMouseDownEvent = _useState16[1];

  var _settings$tourDefault = settings.tourDefaults,
      tourDefaults = _settings$tourDefault === void 0 ? {} : _settings$tourDefault;

  var _ref2 = tour.route || {},
      _ref2$allowedDeviatio = _ref2.allowedDeviation,
      allowedDeviation = _ref2$allowedDeviatio === void 0 ? tourDefaults.allowedDeviation || 500 : _ref2$allowedDeviatio;

  var newWaypointIndex = (0, _react.useRef)(null);
  var tourRouteId = tour === null || tour === void 0 ? void 0 : (_tour$route = tour.route) === null || _tour$route === void 0 ? void 0 : _tour$route.id;
  var tourRouteCoordinates = (_tourRoute$geometry$c = tourRoute === null || tourRoute === void 0 ? void 0 : (_tourRoute$geometry = tourRoute.geometry) === null || _tourRoute$geometry === void 0 ? void 0 : _tourRoute$geometry.coordinates) !== null && _tourRoute$geometry$c !== void 0 ? _tourRoute$geometry$c : []; // request to load the current route of the tour

  (0, _hooks.usePortalFindRoute)({
    portalId: portalId,
    routeId: tourRouteId,
    options: {
      enabled: Boolean(tourRouteId) && ((tourRoute === null || tourRoute === void 0 ? void 0 : tourRoute.id) !== tourRouteId || !tourRoute.geometry),
      onSuccess: function onSuccess(route) {
        return setTourRoute(route);
      },
      onError: function onError() {
        return setEmptyRouteError(true);
      }
    }
  }); // request to calculate the route of the tour

  var _useMutation = (0, _reactQuery.useMutation)(function (routeToCalculate) {
    return request(createRouteFromWaypoints(portalId, routeToCalculate), {
      timeout: 60000
    });
  }, {
    onSuccess: function onSuccess(response) {
      return setTourRoute(response.body.route);
    },
    onError: function onError() {
      return setEmptyRouteError(true);
    }
  }),
      createRouteFromWaypointsRequest = _useMutation.mutate; // calculate new route for tour if route monitoring is enabled and tour doesn't have a route yet


  (0, _hooks.useDidMount)(function () {
    if (isMonitoringEnabled && !tourRouteId) {
      var id = (0, _uuid.v4)();
      onUpdate({
        route: {
          id: id,
          allowedDeviation: allowedDeviation
        }
      });
      setTourRoute({
        id: id,
        geometry: {
          coordinates: []
        }
      });
      createRouteFromWaypointsRequest({
        id: id,
        profile: profile,
        wayPoints: wayPoints
      });
    }
  });
  var dispatchPolyline = (0, _react.useCallback)(function (points) {
    if (Boolean(tourRouteId) && tourRouteCoordinates.length > 0) {
      createRouteFromWaypointsRequest({
        id: tourRouteId,
        profile: profile,
        wayPoints: points
      });
    }
  }, [tourRouteId, tourRouteCoordinates.length, createRouteFromWaypointsRequest, profile]);

  var _useUserMap = (0, _map.useUserMap)({
    mapType: mapType
  }),
      _useUserMap$viewport = _useUserMap.viewport,
      zoom = _useUserMap$viewport.zoom,
      latitude = _useUserMap$viewport.latitude,
      longitude = _useUserMap$viewport.longitude,
      setViewport = _useUserMap.setViewport,
      fitBounds = _useUserMap.fitBounds;

  var _useDimensions = (0, _hooks.useDimensions)(),
      _useDimensions2 = _slicedToArray(_useDimensions, 2),
      container = _useDimensions2[0],
      _useDimensions2$ = _useDimensions2[1],
      viewPortWidth = _useDimensions2$.width,
      viewPortHeight = _useDimensions2$.height;

  var poiMarkers = (0, _react.useMemo)(function () {
    return wayPoints.map(function (waypoint) {
      var point = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [waypoint.lng, waypoint.lat]
        }
      };
      return (0, _helpers.point)(point.geometry.coordinates, {
        wayPointId: waypoint.id,
        status: ['DRIVING'],
        name: waypoint.name,
        category: waypoint.category,
        draggable: false
      });
    });
  }, [wayPoints]);

  var changeDeviationTolerance = function changeDeviationTolerance(allowed) {
    var route = tour.route;
    onUpdate({
      route: Object.assign({}, route, {
        allowedDeviation: allowed
      })
    });
  };

  (0, _react.useEffect)(function () {
    setViewport(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        height: viewPortHeight !== null && viewPortHeight !== void 0 ? viewPortHeight : 0,
        width: viewPortWidth !== null && viewPortWidth !== void 0 ? viewPortWidth : 0
      });
    });
  }, [viewPortHeight, viewPortWidth, setViewport]); // calculate fit bounds for all poi markers, poi geofences and the asset marker (if available)

  (0, _react.useEffect)(function () {
    var features = [];

    if (poiMarkers.length > 0) {
      features = [].concat(_toConsumableArray(features), _toConsumableArray(poiMarkers));
    }

    if (features.length > 0) {
      fitBounds({
        type: 'FeatureCollection',
        features: features
      }, {
        padding: 30
      });
    }
  }, [fitBounds, poiMarkers]);
  var options = [{
    value: 50,
    label: '50 m'
  }, {
    value: 100,
    label: '100 m'
  }, {
    value: 250,
    label: '250 m'
  }, {
    value: 500,
    label: '500 m'
  }, {
    value: 1000,
    label: '1000 m'
  }, {
    value: 2500,
    label: '2500 m'
  }, {
    value: 5000,
    label: '5000 m'
  }];
  var tempRoute = (0, _react.useMemo)(function () {
    return Array.from(tourRouteCoordinates);
  }, [tourRouteCoordinates]);
  var waypointsOnlyLngLat = (0, _react.useMemo)(function () {
    return routeWaypoints.map(function (_ref3) {
      var lat = _ref3.lat,
          lng = _ref3.lng;
      return [lng, lat];
    });
  }, [routeWaypoints]);
  var points = (0, _react.useMemo)(function () {
    return routeWaypoints.map(function (_ref4) {
      var lat = _ref4.lat,
          lng = _ref4.lng;
      return (0, _helpers.point)([lng, lat]);
    });
  }, [routeWaypoints]);
  var insertIntermediateWaypointsRoute = (0, _react.useCallback)(function () {
    waypointsOnlyLngLat.slice(1, waypointsOnlyLngLat.length - 1).forEach(function (waypoint) {
      var newIndex = calculateIndex(tempRoute, waypoint, tempRoute.map(function (position) {
        return (0, _helpers.point)(position);
      }));
      tempRoute.splice(newIndex, 0, waypoint);
    });
  }, [tempRoute, waypointsOnlyLngLat]);
  var calculateWaypointIndex = (0, _react.useCallback)(function (coords) {
    var startWaypoint = waypointsOnlyLngLat[0];
    tempRoute.splice(0, 0, startWaypoint);

    if (routeWaypoints.length > 2) {
      insertIntermediateWaypointsRoute();
    }

    var endWaypoint = waypointsOnlyLngLat[waypointsOnlyLngLat.length - 1];
    tempRoute.splice(tempRoute.length, 0, endWaypoint);
    var newIndex = calculateIndex(tempRoute, coords, points);
    return newIndex;
  }, [insertIntermediateWaypointsRoute, points, routeWaypoints.length, tempRoute, waypointsOnlyLngLat]); // if the cursor on the polyline, create a temporary visible marker and update the position for this one when a mouse down event is active

  var onMapHover = (0, _react.useCallback)(function (event) {
    if (observeMouseDownEvent) {
      setVisibleMarker(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          geometry: _objectSpread(_objectSpread({}, prev === null || prev === void 0 ? void 0 : prev.geometry), {}, {
            coordinates: [event.longitude, event.latitude]
          })
        });
      });
    } else if (event.layerId === 'route') {
      setOnPolyline(true);
      var marker = (0, _helpers.point)([event.longitude, event.latitude], {
        draggable: true
      });
      setVisibleMarker(marker);
    } else {
      setOnPolyline(false);
      setVisibleMarker(null);
    }
  }, [observeMouseDownEvent]); // trigger a mouse down event

  var onMapMouseDown = (0, _react.useCallback)(function (event) {
    if (onPolyline) {
      newWaypointIndex.current = calculateWaypointIndex([event.longitude, event.latitude]);
      setObserveMouseDownEvent(true);
    } else setObserveMouseDownEvent(false);
  }, [onPolyline, calculateWaypointIndex]); // release the mouse down event and create waypoint marker

  var onMapMouseUp = (0, _react.useCallback)(function (event) {
    if (observeMouseDownEvent) {
      var marker = (0, _helpers.point)([event.longitude, event.latitude], {
        draggable: true,
        index: waypointIndex
      });
      setDraggableMarkers(function (prev) {
        return [].concat(_toConsumableArray(prev), [marker]);
      });
      setVisibleMarker(null);
      setObserveMouseDownEvent(false);
      var newWaypoint = {
        lat: event.latitude,
        lng: event.longitude,
        index: waypointIndex
      };
      var newWaypoints = [].concat(_toConsumableArray(routeWaypoints.slice(0, newWaypointIndex.current)), [newWaypoint], _toConsumableArray(routeWaypoints.slice(newWaypointIndex.current)));
      setRouteWaypoints(newWaypoints);
      dispatchPolyline(newWaypoints);
      setWaypointIndex(waypointIndex + 1);
    }
  }, [dispatchPolyline, observeMouseDownEvent, routeWaypoints, waypointIndex]);
  var renderVisibleMarker = (0, _react.useMemo)(function () {
    if (showVisibleMarker && visibleMarker) return /*#__PURE__*/_react["default"].createElement(_routeMarker.PoiMarker, {
      feature: visibleMarker,
      lat: visibleMarker.geometry.coordinates[1],
      lng: visibleMarker.geometry.coordinates[0],
      draggable: true,
      index: 999
    });
    return null;
  }, [visibleMarker, showVisibleMarker]);
  var renderDraggableMarker = (0, _react.useMemo)(function () {
    return draggableMarkers.map(function (draggableMarker, index) {
      return /*#__PURE__*/_react["default"].createElement(_routeMarker.PoiMarker, {
        feature: draggableMarker,
        lat: draggableMarker.geometry.coordinates[1],
        lng: draggableMarker.geometry.coordinates[0],
        onClick: function onClick(id) {
          setDraggableMarkers(function (prev) {
            return prev.filter(function (item) {
              return item.properties.index !== id;
            });
          });
          var removedDuplicate = routeWaypoints.filter(function (item) {
            return item.index !== id;
          });
          dispatchPolyline(removedDuplicate);
          setRouteWaypoints(removedDuplicate);
          setShowVisibleMarker(true);
        },
        onMouseEnter: function onMouseEnter() {
          setShowVisibleMarker(false);
        },
        onMouseLeave: function onMouseLeave() {
          setShowVisibleMarker(true);
        },
        onDragEnd: function onDragEnd(event) {
          setDraggableMarkers(function (prev) {
            return prev.map(function (item, mapIndex) {
              return mapIndex === index ? _objectSpread(_objectSpread({}, item), {}, {
                geometry: _objectSpread(_objectSpread({}, item.geometry.type), {}, {
                  coordinates: [event.lngLat[0], event.lngLat[1]]
                })
              }) : item;
            });
          });
          var newMarkers = routeWaypoints.map(function (marker) {
            if ((marker === null || marker === void 0 ? void 0 : marker.index) === draggableMarker.properties.index) {
              return _objectSpread(_objectSpread({}, marker), {}, {
                lat: event.lngLat[1],
                lng: event.lngLat[0],
                index: draggableMarker.properties.index
              });
            }

            return marker;
          });
          dispatchPolyline(newMarkers);
          setRouteWaypoints(newMarkers);
        },
        draggable: true,
        index: draggableMarker.properties.index
      });
    });
  }, [dispatchPolyline, draggableMarkers, routeWaypoints]);
  var renderPoiMarkers = (0, _react.useMemo)(function () {
    return poiMarkers.map(function (poiMarker, index) {
      return /*#__PURE__*/_react["default"].createElement(_routeMarker.PoiMarker, {
        key: "poi-marker".concat(poiMarker.wayPointId),
        start: index === 0,
        end: index === poiMarkers.length - 1,
        feature: poiMarker,
        lat: poiMarker.geometry.coordinates[1],
        lng: poiMarker.geometry.coordinates[0],
        draggable: poiMarker.draggable,
        index: index
      });
    });
  }, [poiMarkers]);
  var polyline = (0, _react.useMemo)(function () {
    return tourRouteCoordinates.length > 0 ? /*#__PURE__*/_react["default"].createElement(_map.GeoJson, {
      layerId: "route",
      featureStyle: {
        strokeOpacity: 1,
        strokeWeight: 4,
        fillColor: 'transparent'
      },
      feature: (0, _helpers.lineString)(tourRouteCoordinates)
    }) : null;
  }, [tourRouteCoordinates]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-1 flex-col my-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiDropdown, {
    className: "w-72",
    disabled: !isMonitoringEnabled,
    value: allowedDeviation,
    source: options,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.routeDeviationTolerance",
      tagName: "span"
    }),
    onChange: changeDeviationTolerance
  }), (_tour$wayPoints2 = tour.wayPoints) !== null && _tour$wayPoints2 !== void 0 && _tour$wayPoints2.every(function (waypoint) {
    return waypoint.poiId;
  }) ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-96 w-192",
    ref: container
  }, /*#__PURE__*/_react["default"].createElement(_map.BaseMap, {
    mapType: mapType,
    zoom: zoom,
    latitude: latitude,
    longitude: longitude,
    height: "100%",
    width: "100%",
    onViewportChange: setViewport,
    onHover: onMapHover,
    onMouseDown: onMapMouseDown,
    onMouseUp: onMapMouseUp,
    interactiveLayerIds: tourRouteCoordinates.length > 0 ? ['route'] : []
  }, polyline, renderPoiMarkers, renderDraggableMarker, renderVisibleMarker)) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.notAllWaypointsSelected"
  })), emptyRouteError && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.noValidRouteError"
  })));
};

RouteMonitoringSection.propTypes = {
  tour: _propTypes["default"].shape({
    route: _propTypes["default"].shape({
      id: _propTypes["default"].string,
      allowedDeviation: _propTypes["default"].number
    }),
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    assetType: _propTypes["default"].number
  }),
  tourRoute: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    properties: _propTypes["default"].shape({
      time: _propTypes["default"].number,
      distance: _propTypes["default"].number
    }),
    geometry: _propTypes["default"].shape({
      coordinates: _propTypes["default"].arrayOf(_propTypes["default"].number)
    })
  }),
  onUpdate: _propTypes["default"].func,
  setTourRoute: _propTypes["default"].func,
  isMonitoringEnabled: _propTypes["default"].bool
};

var noop = function noop() {};

RouteMonitoringSection.defaultProps = {
  isMonitoringEnabled: false,
  tour: {
    route: null
  },
  tourRoute: {},
  onUpdate: noop,
  setTourRoute: noop
};
var _default = RouteMonitoringSection;
exports["default"] = _default;